const fetchWithCredentials = (
  url: RequestInfo,
  options: RequestInit = {}
): Promise<Response> =>
  fetch(url, {
    credentials: 'include',
    mode: 'cors',
    ...options
  })

export default fetchWithCredentials
